import { inject } from "@angular/core";
import { CanActivateFn } from "@angular/router";
import { EmbedTokenService } from "./components/shared/embed-token.service";

/**
 * Gate for the iframe routes. The host app passes the token in the URL fragment
 * (/embed/dashboard?embed=prism#token=...) — a fragment is never sent to a server, so it stays out of
 * access logs and Referer headers. It is moved into memory and scrubbed from the address bar.
 */
export const embedGuard: CanActivateFn = () => {
    const embed = inject(EmbedTokenService);
    if (new URLSearchParams(window.location.search).get('embed') !== 'prism') {
        return false;
    }
    const token = new URLSearchParams(window.location.hash.replace(/^#/, '')).get('token');
    if (token) {
        embed.token = token;
        history.replaceState(null, '', window.location.pathname + window.location.search);
    }
    return embed.active;
};
